import React, { useEffect, useState } from "react";
import { trainingApi } from "../../services/trainingApi";
import { StatusBadge } from "../../components/StatusBadge";
import { PageHelpBanner } from "../../components/PageHelpBanner";
import { useLocalization } from "../../hooks/useLocalization";

export default function MyCertificationsPage() {
  const { t } = useLocalization();
  const [certifications, setCertifications] = useState([]);
  useEffect(() => { trainingApi.myCertifications().then((r) => setCertifications(r.data)).catch(() => {}); }, []);
  const today = new Date().toISOString().slice(0, 10);

  return (
    <div className="space-y-4" data-testid="my-certifications-page">
      <PageHelpBanner pageKey="my-certifications" title={t("pageHelp.defaultTitle")}>
        <p>{t("pageHelp.myCertifications")}</p>
      </PageHelpBanner>
      <div>
        <h2 className="text-xl font-bold tracking-tight text-gray-900">{t("myCertifications.title")}</h2>
        <p className="text-sm text-gray-500">{t("myCertifications.subtitle")}</p>
      </div>
      {certifications.map((c) => (
        <div key={c.id} className="bg-white border border-gray-200 rounded-xl p-4 flex items-center justify-between" data-testid={`my-certifications-row-${c.id}`}>
          <div>
            <p className="text-sm font-semibold text-gray-800">{c.certification_key}</p>
            <p className="text-xs text-gray-500">{t("myCertifications.issued")}: {(c.issued_at || "").slice(0, 10)} · {t("myCertifications.expires")}: {c.expires_at ? c.expires_at.slice(0, 10) : t("myCertifications.never")}</p>
          </div>
          <StatusBadge status={c.expires_at && c.expires_at.slice(0, 10) <= today ? "EXPIRED" : c.status} />
        </div>
      ))}
      {certifications.length === 0 && <p className="text-sm text-gray-500" data-testid="no-my-certifications-row">{t("myCertifications.noCertifications")}</p>}
    </div>
  );
}
